<template>
  <Anicss
    appear
    :enter-active-class="enterActiveClass"
  >
    <NextButton
      v-bind="$attrs"
      v-on="$listeners"
      :class="$style.root"
    />
  </Anicss>
</template>

<script>
import NextButton from '@/components/NextButton'
import Anicss from '@/components/Anicss'

export default {
  components: {
    NextButton,
    Anicss,
  },
  props: {
    noAni: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    enterActiveClass () {
      return this.noAni ? [] : ['animated', 'bounceIn']
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply absolute;
  @apply inset-y-0;
  @apply right-0;
  @apply mr-8;
  @apply flex;
  @apply items-center;
}
</style>
